import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import MembershipContactDetailsPanel from "../../components/MembershipContactDetailsPanel";
import MembershipPanelWrapper from "../../components/MembershipPanelWrapper";
import { useEffect } from "react";
import { trackPageViewV2 } from "../../../../services/analytics-adapter";

export default function MembershipContactDetailsPage() {
  const { t } = useTranslation();
  const { membershipIdentifier } = useParams();

  useEffect(() => {
    trackPageViewV2({
      pageName: "Membership:Membership contact details",
      pageSubSection1: "Membership",
      pageSubSection2: "Membership:Membership contact details",
      pageCategory: "Membership",
    });
  }, [membershipIdentifier]);

  return (
    <MembershipPanelWrapper
      goBackButtonText={t("MembershipContactDetailsPage.goBackButton")}
      goBackButtonVisibleText={t(
        "MembershipContactDetailsPage.goBackButtonVisibleLabel"
      )}
    >
      <MembershipContactDetailsPanel
        membershipIdentifier={membershipIdentifier}
      />
    </MembershipPanelWrapper>
  );
}
